import {
  Box,
  Button,
  CardMedia,
  Grid,
  Badge,
  IconButton,
  Pagination,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Menu,
  TextField,
  useTheme,
  TablePagination,
  Theme,
  DialogActions,
  DialogContent,
  Dialog,
  DialogTitle,
  Hidden,
  List,
  ListItemButton,
  MenuItem,
  Tooltip,
  CircularProgress,
  Divider,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { CommonLayout, ConfirmationDialog, LoadingDialog } from '../commonComponents';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router';
import { ChangeEvent, useEffect, useState } from 'react';
import { getAllApplications, getApplicationDetails } from '../../redux-store/actions/application';
import { useDispatch, useSelector } from 'react-redux';
import { FilterDropdown, initialFilters } from '../investors/filters';
// import { Distributor, getDistributorsListForFilters } from '../../redux-store/actions';
import { Applicant, ApplicationFilterType, CopyLinkResponse, investmentDetailsAplicationRef } from '../../redux-store/types/api-types';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import React from 'react';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
import { useDebounce } from '../../utils/useDebounce';
import DashboardAndApplicationsList, { getBseClientActivationStatusMsg } from '../dashboard/applicationslist';
import { Formik } from 'formik';
import MFCheckbox from '../../lib/formik/Checkbox';
import { ActionIcon, DialogCloseIcon, EditIcon, FilterIcon, InfoIconOutlined, PlusIcon, SearchIcon } from '../../assets/SvgIcons';
import { Delete, Filter, Info, Redo } from '@mui/icons-material';
import { APPLICATION_LISTING_STATUS, APPLICATION_OTP_CONSENT_STATUS, APPLICATION_RE_KYC_STATUS, MPOWER_ACCOUNT_TYPE_MASTER, ONBOARDING_VIA_OPTIONS, PHYSICAL_DIGITAL_FLOW, USER_ROLES } from '../../utils/constant';
import { whiteSpaceOnlyRegex } from '../../utils/regex';
import { ColumnType, DataTable } from '../DataTable';
import { applicationDownloadStatusCheck, checkIfApplicationIsNonIndividual, getFirstHolderName, getFirstHolderPan, getIndividualType, isModuleAllowed, isOnboardingTypeMinor, maskInfo,getModeOfHoldingDisplay, isApplicationNonIndividual, } from '../../utils/utilityFunctions';
import { useSnackbar } from 'notistack';
import { reportDownload } from '../Reports/report-utils';
import { ApplicationDownload, ApplicationRefs, CopyLink } from '../../redux-store/actions/onBoarding';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { CheckConsentCompleted, CheckConsentCompletedBody, GetResendOtpBody, ResendConsentMail } from '../../redux-store/actions/otpConsent';
import dayjs from 'dayjs';

interface Values {
  pan: string;
}

interface FilterProps {
  filters: ApplicationFilterType,
  open: boolean,
  handleFiltersAnchorEl: () => void,
  filtersAnchorEl: boolean,
  setPage: React.Dispatch<React.SetStateAction<number>>,
  setFilters: React.Dispatch<React.SetStateAction<ApplicationFilterType>>
  handleFiltersAnchorElClose: () => void,
  distributorLoading: boolean,
  totalFilters?: number,
  setTotalFilters?: React.Dispatch<React.SetStateAction<number>>
}

const getTableHeader = (): ColumnType[] => {
  const { permissions } = useSelector((state: RootStateType) => state.auth);
  return [
    {
      header: 'Application Number',
      label: 'customerId',
      valueGetter: (row: ApplicationProps) => row.applicationNumber || 'N/A',
    },
    {
      header: 'Investor Name',
      valueGetter: ({ applicants = [], onboardingType }: ApplicationProps) =>
        maskInfo(isOnboardingTypeMinor(onboardingType as string) ? applicants[0]?.minorName || 'N/A' : getFirstHolderName(applicants)) || 'N/A',
    },
    {
      header: 'Mode of Holding',
      renderCell: (row: ApplicationProps) => {
        return (
          <Typography
            sx={{
              textTransform: 'capitalize',
            }}>
            {getModeOfHoldingDisplay(row.modeOfHolding)??'-'}
          </Typography>
        );
      },
    },
    {
      header: 'Investor PAN',
      valueGetter: ({ applicants = [] }: ApplicationProps) => maskInfo(getFirstHolderPan(applicants)) || 'N/A',
    },
    {
      header: 'Investor Type',
      valueGetter: ({ applicants = [], onboardingType }: ApplicationProps) => getIndividualType(applicants?.[0]?.status ?? '', onboardingType ?? '') || 'N/A',
    },
    // {
    //   header: 'Account Type',
    //   valueGetter: (row: ApplicationProps) => MPOWER_ACCOUNT_TYPE_MASTER[row?.accountType] ?? 'N/A',
    // },
    {
      header: 'Consent Status',
      valueGetter: (row: ApplicationProps) => {
        const { palette } = useTheme()
        const consentOtpStatuses = row.applicants.map((applicant, index) => {
          const consentAtField: string =  [
            'firstApplicantConsentAt',
            'secondApplicantConsentAt',
            'thirdApplicantConsentAt',
          ][index];

          const status = row[consentAtField as keyof ApplicationProps] !== null ? 'verified' : 'pending';

          return { holder: applicant?.name, status, originalIndex: index + 1 };
        });

        const pendingApplicants = consentOtpStatuses
          .filter((status) => status.status === 'pending')
          .map((status) => status.originalIndex.toString());

        const allVerified = consentOtpStatuses.every((status) => status.status === 'verified');

        return (
          <Box
            className={APPLICATION_OTP_CONSENT_STATUS[allVerified ? 'verified' : 'pending']}
            sx={{
              '& .MuiTypography-root': {
                fontWeight: 500,
                color: '#B78813',
              },
              '&.Pending .MuiTypography-root': {
                color: palette.primary[500],
              },
              '&.Verified .MuiTypography-root': {
                color: palette.success[500],
              },
            }}>
            <Typography
              sx={{ textDecoration: 'none' }}>
              {allVerified ? 'Verified' :  `Pending - Applicant ${pendingApplicants.join(', ')}`}
            </Typography>
          </Box>
        );
      },
    },
    {
      header: 'BSE Status',
      valueGetter: (row: ApplicationProps) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: "nowrap" }}>
            <Typography
              variant='body_500'
            >
              {row?.isBSEEnabled
                ? row?.bseClientActivationStatus
                  ? getBseClientActivationStatusMsg(row?.bseClientActivationStatus)
                  : 'MF Enabled'
                : 'MF Disabled'
              }
            </Typography>
            {isModuleAllowed({ value: "BSEStatus", compareArr: permissions, objKey: "permissonCode" }) && <Tooltip
              slotProps={{
                tooltip: {
                  sx: {
                    margin: "0px !important",
                    backgroundColor: "transparent"
                  }
                }
              }}
              title={
                <Box sx={{
                  borderRadius: '10px',
                  backgroundColor: '#0F131F',
                  padding: '10px',
                  display: 'flex',
                  flexDirection: 'column',
                  rowGap: '10px'  // Gap between each section
                }}>
                  {row?.isBSEEnabled ?
                    <>
                      <Box>
                        <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                          STATUS
                        </Typography>
                        <Typography variant='subtitle_600'>
                          {row?.bseStarServiceResponse ?? '-'}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                          CLIENT CREATION RESPONSE
                        </Typography>
                        <Typography variant='subtitle_600'>
                          {row?.bseStarResponse ?? '-'}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                          FATCA RESPONSE
                        </Typography>
                        <Typography variant='subtitle_600'>
                          {row?.bseFatcaResponse ?? '-'}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                          CHEQUE UPLOAD RESPONSE
                        </Typography>
                        <Typography variant='subtitle_600'>
                          {row?.cancelChequeUploadResponse ?? '-'}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                          AOF IMAGE RESPONSE
                        </Typography>
                        <Typography variant='subtitle_600'>
                          {row?.bseAofImageResponse ?? '-'}
                        </Typography>
                      </Box>
                    </>
                    :
                    <Box sx={{ textAlign: 'center', borderBottom: '1px solid #333333' }}>
                      <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                        Mutual Fund Transaction Disabled
                      </Typography>
                    </Box>
                  }
                  <Box>
                    <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                      MPOWER STATUS
                    </Typography>
                    <Typography variant='subtitle_600'>
                      {row?.mpowerResponse || '-'}
                    </Typography>
                  </Box>
                </Box>
              }
            >
              <IconButton>
                <InfoIconOutlined />
              </IconButton>
            </Tooltip>}
          </Box>
        )
      },
    },
    {
      header: 'Status',
      renderCell: (row: ApplicationProps) => {
        const { palette } = useTheme()
        const applicationStatus = APPLICATION_LISTING_STATUS[row.status];
        return (
          <Box
            className={APPLICATION_LISTING_STATUS[row.status]}
            sx={{
              '& .MuiTypography-root': {
                fontWeight: 500,
                // fontSize: 16,
                color: '#B78813',
              },
              '&.Draft .MuiTypography-root': {
                color: palette.primary[500],
              },
              '&.Completed .MuiTypography-root': {
                color: palette.success[500],
              },
              '&.Rejected .MuiTypography-root': {
                color: palette.error[500],
              },
              '&.Sent .MuiTypography-root': {
                color: palette.warning[500],
              },
              '&.Invitation .MuiTypography-root': {
                color: palette.text.secondary + 'b2',
              },
            }}>
            <Typography
              component={RouterLink}
              to={
                checkIfApplicationIsNonIndividual(row)
                  ? `/non-individual-application-details/${row.id}`
                  : `/application-details/${row.id}`
              }
              sx={{ textDecoration: 'none' }}>
              {`${APPLICATION_LISTING_STATUS[row.status]} ${row.applicationSentBack ? '(Sent Back)' : ''}`}
              {(row?.status) &&
                <Tooltip
                  slotProps={{
                    tooltip: {
                      sx: {
                        margin: "0px !important",
                        backgroundColor: "transparent"
                      }
                    }
                  }}
                  title={
                    <Box sx={{
                      textAlign: 'flex-start',
                      borderRadius: '10px',
                      backgroundColor: '#0F131F',
                      padding: '8px'
                    }}>
                      {/* {row?.rekycStatus && (
                                      <>
                                        <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                          REKYC STATUS
                                        </Typography>
                                        <Typography variant='subtitle_600'>
                                          {APPLICATION_RE_KYC_STATUS[row?.rekycStatus] || row?.rekycStatus || 'N/A'}
                                        </Typography>
                                      </>
                                    )} */}

                      {row?.status && (
                        <>
                          {/* {row?.rekycStatus && <Divider sx={(theme:Theme)=>({my: 1, borderColor: theme.palette.primary[50] })} />} */}

                          <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                            ONBOARDING DATE
                          </Typography>
                          <Typography variant='subtitle_600'>
                            {row?.applicants[0]?.createdAt ? dayjs(row?.applicants[0]?.createdAt).format('DD-MM-YYYY') : 'NA'}
                          </Typography>
                          <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', marginTop: '8px', color: theme.palette.primary[500] })}>
                            APPLICATION DATE
                          </Typography>
                          <Typography variant='subtitle_600'>
                            {isApplicationNonIndividual(row?.applicationType)  ? (row?.amcApproverApprovedAt ? dayjs(row?.amcApproverApprovedAt).format('DD-MM-YYYY') : 'NA') : (row?.firstApplicantConsentAt ? dayjs(row?.firstApplicantConsentAt).format('DD-MM-YYYY') : 'NA')}
                          </Typography>

                          <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', marginTop: '8px', color: theme.palette.primary[500] })}>
                            CHECKER APPROVAL DATE
                          </Typography>
                          <Typography variant='subtitle_600'>
                            {row?.amcApproverApprovedAt ? dayjs(row?.amcApproverApprovedAt).format('DD-MM-YYYY') : 'NA'}
                          </Typography>
                          {row?.rejectedAt &&
                            <>
                              <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', marginTop: '8px', color: theme.palette.primary[500] })}>
                                CHECKER REJECTED DATE
                              </Typography>
                              <Typography variant='subtitle_600'>
                                {row?.rejectedAt ? dayjs(row?.rejectedAt).format('DD-MM-YYYY') : 'NA'}
                              </Typography>
                            </>}
                        </>
                      )}
                    </Box>
                  }
                >
                  <IconButton>
                    <InfoIconOutlined />
                  </IconButton>
                </Tooltip>}
            </Typography>
          </Box>
        );
      },
    },

  ];
}

const ResendOtpDialog = ({ isResendOtpDialogOpen, handleResendOtpDialogClose, resendOTPDialogId, application }: { isResendOtpDialogOpen: boolean; handleResendOtpDialogClose: () => void; resendOTPDialogId: string; application: ApplicationProps }): JSX.Element => {

  if (!isResendOtpDialogOpen) return <></>;

  const { applicants, id } = application

  type otpSendMessageType = {
    PRIMARY: {
      message: string;
      loading: boolean;
      disabled: boolean;
    };
    JOINT_1: {
      message: string;
      loading: boolean;
      disabled: boolean;
    };
    JOINT_2: {
      message: string;
      loading: boolean;
      disabled: boolean;
    };
  }

  const typeMapping: { [key: string]: string } = {
    PRIMARY: '1',
    JOINT_1: '2',
    JOINT_2: '3',
  };


  const [otpSendMessage, setOtpSendMessage] = useState<otpSendMessageType>({
    PRIMARY: {
      message: 'Loading...',
      loading: false,
      disabled: true
    },
    JOINT_1: {
      message: 'Loading...',
      loading: false,
      disabled: true
    },
    JOINT_2: {
      message: 'Loading...',
      loading: false,
      disabled: true
    },
  });
  const [copyLinkLoading, setCopyLinkLoading] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const handleResendOTP = async (type: string) => {
    const applicantType = typeMapping[type];
    try {
      setOtpSendMessage((prev) => ({ ...prev, [type]: { message: '', loading: true } }));
      const applicant = applicants.find((applicant) => applicant.applicant_type === applicantType);
      const response = await dispatch(ResendConsentMail({ applicationId: resendOTPDialogId, applicantId: applicant?.id ?? '' })) as unknown as GetResendOtpBody;

      if (response?.message) {
        enqueueSnackbar('Link successfully sent to Investor.', {
          variant: 'success',
          autoHideDuration: 2000,
        });
        setOtpSendMessage((prev) => ({ ...prev, [type]: { message: "Resend Link", loading: false, disabled: false } }));
      }

    } catch {
      setOtpSendMessage((prev) => ({ ...prev, [type]: { message: 'Try Again', loading: false } }));
    }

  };

  const getApplicantName = (type: string) => {
    const applicantType = typeMapping[type];
    const applicant = applicants?.find((applicant) => applicant.applicant_type === applicantType);
    return applicant ? `${applicant.name}` : '';
  };

  useEffect(() => {
    (async () => {
      try {
        // setOtpSendMessage((prev) => ({
        //   ...prev,
        //   PRIMARY: {
        //     message: 'Loading...',
        //     loading: true,
        //     disabled: false
        //   },
        //   JOINT_1: {
        //     message: 'Loading...',
        //     loading: true,
        //     disabled: false
        //   },
        //   JOINT_2: {
        //     message: 'Loading...',
        //     loading: true,
        //     disabled: false
        //   },
        // }))
        const response = await dispatch(CheckConsentCompleted(resendOTPDialogId)) as unknown as CheckConsentCompletedBody;
        // if(!response){
        //   handleResendOtpDialogClose();
        // }
        if (response?.message) {
          const applicantPending = applicants.filter((applicant) => response?.result?.applicantsIds?.includes(applicant?.id ?? ''));
          if (applicantPending.length > 0) {
            applicants.map((applicant) => {
              const type = applicant.applicant_type === '1' ? 'PRIMARY' : applicant.applicant_type === '2' ? 'JOINT_1' : 'JOINT_2';
              if (applicantPending.includes(applicant)) {
                return setOtpSendMessage((prev) => ({
                  ...prev,
                  [type]: {
                    message: 'Resend Link',
                    loading: false,
                    disabled: false
                  }
                }))
              } else {
                return setOtpSendMessage((prev) => ({
                  ...prev,
                  [type]: {
                    message: 'Consent Verified',
                    loading: false,
                    disabled: true
                  }
                }))
              }
            })
          } else {
            setOtpSendMessage((prev) => ({
              ...prev,
              PRIMARY: {
                message: 'Consent Verified',
                loading: false,
                disabled: true
              },
              JOINT_1: {
                message: 'Consent Verified',
                loading: false,
                disabled: true
              },
              JOINT_2: {
                message: 'Consent Verified',
                loading: false,
                disabled: true
              },
            }))
          }
        }
      } catch {
        setOtpSendMessage((prev) => ({
          ...prev,
          PRIMARY: {
            message: 'Resend Link',
            loading: false,
            disabled: false
          },
          JOINT_1: {
            message: 'Resend Link',
            loading: false,
            disabled: false
          },
          JOINT_2: {
            message: 'Resend Link',
            loading: false,
            disabled: false
          },
        }))
      }
    })()
  }, [isResendOtpDialogOpen])

  // const handleCopyLink = (type: string) => {
  //   const applicantType = typeMapping[type];
  //   const applicant = applicants.find((applicant) => applicant.applicant_type === applicantType);
  //   navigator.clipboard.writeText(`${window.location.origin}/consent-otp/${applicant?.id}/${applicant?.userId}/${application?.uuid}`);
  //   enqueueSnackbar('Link copied to clipboard successfully.', {
  //     variant: 'success',
  //     autoHideDuration: 2000,
  //   })
  // }
  const handleCopyLink = async (type: string) => {
    const applicantType = typeMapping[type];
    const applicant = applicants.find((applicant) => applicant.applicant_type === applicantType);
    setCopyLinkLoading(true);
    try {
      const response = await dispatch(CopyLink({
        applicationId: id,
        applicantId: applicant?.id,
      })) as unknown as CopyLinkResponse;
      // Copy to clipboard using the API response UUID
      if (response?.isSuccess) {
        navigator.clipboard.writeText(`${window.location.origin}/consent-otp/${applicant?.id}/${applicant?.userId}/${response?.data?.token}`);
        enqueueSnackbar('Link copied to clipboard successfully.', {
          variant: 'success',
          autoHideDuration: 2000,
        });
      } else {
        enqueueSnackbar('Failed to copy link. Please Resend Link', {
          variant: 'error',
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      // console.error('Error copying link:', error);
      enqueueSnackbar('Failed to copy link.', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    } finally {
      setCopyLinkLoading(false);
    }
  }
  // const isJointHolder = application?.modeOfHolding === 'joint';
  return (
    <Dialog
      onClose={handleResendOtpDialogClose}
      open={isResendOtpDialogOpen}
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "15px",
          backgroundColor: "background.default",
          maxWidth: "600px",
          padding: "25px",
          m: 0
        }
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h2" sx={{ fontWeight: 600 }}>
            Resend/Copy Consent Link
          </Typography>
          <IconButton onClick={handleResendOtpDialogClose}>
            <DialogCloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Grid container spacing={2} sx={{ mb: 2, display: "flex", flexDirection: "column" }}>
            {["PRIMARY", "JOINT_1", "JOINT_2"].map((type) => {
              const name = getApplicantName(type as string);
              if (!name) return null;
              return (
                <Grid container item xs={12} key={type} sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", sm: "row" } }}>
                  <Grid item sm={6} xs={12} sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="body_500" sx={{ fontWeight: 600, mb: 1 }}>
                      {type === "PRIMARY" ? "Applicant" : "Joint Holder"} ({type === "PRIMARY" ? "Primary" : type === "JOINT_1" ? "Joint Holder 1" : "Joint Holder 2"})
                    </Typography>
                    <Typography variant="body_500" sx={{ fontWeight: 400 }}>
                      {name}
                    </Typography>
                  </Grid>
                  <Grid container item sm={6} xs={12} key={type} spacing={2}>
                    <Grid item xs={6} >
                      <Button
                        variant="outlined"
                        fullWidth
                        disabled={otpSendMessage[type as keyof otpSendMessageType].disabled}
                        onClick={() => handleResendOTP(type)}
                        sx={(theme: Theme) => ({
                          padding: "10px",
                          borderColor: "primary.500",
                          color: "primary.500",
                          borderWidth: "1px",
                          "&:hover": {
                            backgroundColor: "background.paper",
                            borderColor: "primary.600"
                          },
                          ...theme.typography.body_600
                        })}
                      >
                        {
                          otpSendMessage[type as keyof otpSendMessageType].loading ? <CircularProgress color="primary" size={20} /> : otpSendMessage[type as keyof otpSendMessageType].message
                        }
                      </Button>
                    </Grid>
                    <Grid item xs={6} >
                      <Button
                        variant="outlined"
                        fullWidth
                        disabled={otpSendMessage[type as keyof otpSendMessageType].disabled}
                        onClick={() => handleCopyLink(type)}
                        sx={(theme: Theme) => ({
                          padding: "10px",
                          borderColor: "primary.500",
                          color: "primary.500",
                          borderWidth: "1px",
                          "&:hover": {
                            backgroundColor: "background.paper",
                            borderColor: "primary.600"
                          },
                          ...theme.typography.body_600
                        })}
                      >
                        Copy Link
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>


              );
            })}
          </Grid>
        </Box>

        <DialogActions sx={{ pt: 4 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleResendOtpDialogClose}
                sx={(theme: Theme) => ({
                  padding: "10px",
                  ...theme.typography.body_600
                })}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export default function AccountStatus(): JSX.Element {
  const history = useHistory();
  const { palette } = useTheme()
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [applicationsList, setApplicationsList] = useState<ApplicationProps[]>([]);
  const [noOfPages, setNoPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0)
  const [limit, setLimit] = useState(10);
  const {
    page,
    search: storeSearch,
    status: storeStatus,
    applicationType: storeApplicationType,
    modeOfHolding: storeModeOfHolding,
    distributorId: storeDistributorId,
    diy: storeDIY,
    accountType: storeAccountType,
    onboardingType: storeOnboardingType,
    bseClientActivationStatus: storeBseStatus,
    applicationSentBack,
  } = useSelector((store: RootStateType) => store.paramsObj);
  const [currentPage, setPage] = useState(page);
  const [open, setOpen] = useState(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<boolean>(false);
  // const [distributors, setDistributors] = useState<Distributor[]>([]);
  const [filters, setFilters] = useState<ApplicationFilterType>(
    initialFilters(
      role,
      applicationSentBack ? storeStatus.replace('draft', 'draft_send_back') : storeStatus,
      storeApplicationType,
      storeModeOfHolding,
      storeDistributorId,
      storeDIY,
      storeAccountType,
      storeBseStatus,
      storeOnboardingType
    )
  );
  const { applicationType, distributorId, status, modeOfHolding, diy, accountType, onboardingType, bseClientActivationStatus } = filters;
  const [search, setSearch] = useState(storeSearch);
  const debounceSearchString = useDebounce(search, 500);
  const [distributorLoading, setDistributorLoading] = useState(false);
  const [totalFilters, setTotalFilters] = useState<number>(0);
  const [applicationsListData, setApplicationsListData] = useState<ApplicationProps[]>([]);
  const [deletePopUp, setDeletePopUp] = useState<{ id: string } | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const [isDialogLoading, setDialogLoading] = useState(false);
  const [id, setId] = useState('');
  const [checkPoaOrNI, setCheckPoaOrNI] = useState(false);
  const [tooltip, setTooltip] = useState('Click to Copy');
  const [applicationRefsList, setApplicationRefsList] = useState<investmentDetailsAplicationRef[]>(
    []
  );
  const [isResendOtpDialogOpen, setResendOtpDialogOpen] = useState<boolean>(false);
  const [resendOTPDialogId, setResendOTPDialogId] = useState<string>('');
  const [resendOTPApplicants, setResendOTPApplicants] = useState<ApplicationProps>({} as ApplicationProps);

  const theme = useTheme();
  const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId', 'diy', 'accountType', 'bseClientActivationStatus', 'onboardingType'].filter(
    (filterKey) => (filters[filterKey] as string[])?.length
  )?.length;

  const handleClose = () => {
    setOpen(false), setId('');
  };
  const handleDialogClose = () => {
    setDialogLoading(false);
    setOpen(true);
  };

  const handleResendOtpDialogClose = () => {
    setResendOtpDialogOpen(false);
  }

  useEffect(() => {
    getApplication()
  }, [currentPage, debounceSearchString, filters]);

  useEffect(() => {
    setApplicationsListData(applicationsList);
  }, [applicationsList]);

  useEffect(() => {
    let componentIsAlive = true;
    (async function () {
      try {
        if (id) {
          const responseApplicationRefsList = (await dispatch(
            ApplicationRefs(id)
          )) as unknown as investmentDetailsAplicationRef[];
          if (!componentIsAlive) {
            return;
          }
          setApplicationRefsList(responseApplicationRefsList);
          handleDialogClose();
        }
      } catch (e) {
        setDialogLoading(false);
        console.error((e as Error).message);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, [id]);

  const getApplication = async () => {
    setLoading(true);
    setApplicationsList([]);
    try {
      const response = (await dispatch(
        getAllApplications({
          page: currentPage,
          search,
          applicationType: applicationType.toString(),
          distributorId: distributorId.toString(),
          status: status
            .toString()
            .replace('draft_send_back', 'draft')
            .replace('draft,draft', 'draft'),
          modeOfHolding: 'joint,either or survivor',
          applicationSentBack:
            status.includes('draft_send_back') && !status.includes('draft') ? true : null,
          diy: diy?.toString(),
          accountType: accountType?.toString(),
          bseClientActivationStatus: bseClientActivationStatus?.toString(),
          onboardingType: onboardingType?.toString(),
          rekycStatus: 'null,completed,pending,pending_from_mpower',
        })
      )) as unknown as GetAllApplicantionsResponseBody;
      const { applications, pages, total, limit } = response || {};
      setApplicationsList(applications);
      setNoPages(pages);
      setTotalCount(total)
      setLimit(limit);
      setLoading(false);

      if (response) {
        const totalAppliedFilters = (applicationType?.length || 0) + (distributorId?.length || 0) + (status?.length || 0) + (diy?.length || 0) + (accountType?.length || 0) + (onboardingType?.length || 0) + (bseClientActivationStatus?.length || 0);

        setTotalFilters(totalAppliedFilters);
      }
    } catch (e) {
      console.error((e as Error).message);
      setLoading(false);
    }
  }

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleSearchText = (event: ChangeEvent<HTMLInputElement>) => {
    const searchedText = event.target.value.replace(/^\s+/g, '').replace(/\s+/g, ' ');
    event.target.value = searchedText;
    setPage(1);
    if (whiteSpaceOnlyRegex.test(searchedText)) return;
    setSearch(event.target.value);
  }

  const handleFiltersAnchorEl = async () => {
    try {
      setFiltersAnchorEl(true);
      // setDistributorLoading(true);
      // const distributorList = (await dispatch(
      //   getDistributorsListForFilters()
      // )) as unknown as Distributor[];
      // setDistributors(distributorList);
      setDistributorLoading(false);
    } catch (e) {
      console.error((e as Error).message);
      setDistributorLoading(false);
    }
  };

  const handleFiltersAnchorElClose = () => {
    setFiltersAnchorEl(false);
  };

  const additionalCell = {
    header: 'Action',
    renderEditDeleteCell: (row: ApplicationProps): JSX.Element => {
      const [loadingPopup, setLoadingPopup] = useState(false);
      const { palette } = useTheme()
      const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
      const [selectedIndex, setSelectedIndex] = React.useState(1);
      const open = Boolean(anchorEl);
      const { role = '' } = useSelector((store: RootStateType) => store.auth);

      const [viewInfoOpen, setViewInfoOpen] = useState(false);
      const handleOpen = () => setViewInfoOpen(true);
      const handleClose = () => setViewInfoOpen(false);
      const history = useHistory();

      const options = [
        {
          label: 'Edit',
          name: 'edit',
          disable: `${row?.status ?? ''}`?.toLowerCase() !== 'draft'
        },
        [USER_ROLES.RM].includes(role) && row?.status?.toLowerCase() === 'consent_sent_to_applicants' &&
        {
          label: 'Resend/Copy Link',
          name: 'resend',
          // disable: `${row?.status ?? ''}`?.toLowerCase() !== 'consent_sent_to_applicants'
          disable: false
        },
        [USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role) && {
          label: 'Delete',
          name: 'delete',
          disable: !row.deletable || `${row?.status}`?.toLowerCase() === 'completed'
        },
        // {
        //   label: 'View Info',
        //   name: 'info',
        // },
        {
          label: 'Download',
          name: 'download',
          disable: [APPLICATION_LISTING_STATUS.rejected].includes(APPLICATION_LISTING_STATUS[row.status]) ? true : false
        },
        // !['draft', 'rejected', 'sent_to_investor', 'sent_to_poa_approver', 'sent_to_amc_approver', 'completed', 'signed'].includes(row.status) && row?.isEsignEnabled && {
        //   label: 'Link',
        //   name: 'link',
        //   disable: false
        // },
      ];

      const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
      };

      const handleMenuItemClick = (
        event: React.MouseEvent<HTMLElement>,
        index: number,
        option: {
          label: string;
          name: string;
        }
      ) => {
        if (option.name === 'resend') resendHandler()
        else if (option.name === 'delete') deleteHandler()
        else if (option.name === 'download') downloadHandler()
        else if (option.name === 'link') linkHandler()
        else if (option.name === 'info') infoHandler()
        else if (option.name === 'edit') editHandler()

        setSelectedIndex(index);
        setAnchorEl(null);
      };

      const handleCloseMenu = () => {
        setAnchorEl(null);
      };

      const resendHandler = () => {
        setResendOtpDialogOpen(true);
        setResendOTPDialogId(row.id);
        setResendOTPApplicants(row);
      }
      const deleteHandler = () => {
        setDeletePopUp({ id: row.id })
      }

      const downloadHandler = async () => {
        try {
          // Below if condition checks if application status is NOT completed 
          if (![APPLICATION_LISTING_STATUS.rejected].includes(APPLICATION_LISTING_STATUS[row.status])) {
            setLoadingPopup(true);
            const res = (await dispatch(ApplicationDownload(row.id))) as unknown as any;
            if (!res) {
              setLoadingPopup(false);
              enqueueSnackbar('Download failed', {
                variant: 'error',
                autoHideDuration: 3000,
              });
              return;
            }
            reportDownload(res as unknown as Blob, `${row.id}.pdf`);
            setLoadingPopup(false);
            enqueueSnackbar('Downloaded successfully', {
              variant: 'success',
              autoHideDuration: 3000,
            });
            return;
          }

          if (
            PHYSICAL_DIGITAL_FLOW &&
            ONBOARDING_VIA_OPTIONS[(row?.onboardingVia ?? "")?.toLowerCase()] === ONBOARDING_VIA_OPTIONS['physical']
          ) {
            setLoadingPopup(true);
            const res = (await dispatch(ApplicationDownload(row.id))) as unknown as any;
            if (!res) {
              setLoadingPopup(false);
              enqueueSnackbar('Download failed', {
                variant: 'error',
                autoHideDuration: 3000,
              });
              return;
            }
            reportDownload(res as unknown as Blob, `${row.id}.pdf`);
            setLoadingPopup(false);
            enqueueSnackbar('Downloaded successfully', {
              variant: 'success',
              autoHideDuration: 3000,
            });
            return;
          }

          if (row?.signedLeegalityFile?.url) {
            window.open(row?.signedLeegalityFile?.url, '_self');
            enqueueSnackbar('Downloaded successfully', {
              variant: 'success',
              autoHideDuration: 3000,
            });
          }
        } catch (e) {
          setLoadingPopup(false);
          console.error((e as Error).message);
        }
      }

      const linkHandler = () => {
        setId(row.id as string),
          setDialogLoading(true),
          setCheckPoaOrNI(row.hasPOA || checkIfApplicationIsNonIndividual(row));
      }

      const infoHandler = () => {
        history.push(`/investor-onboarding-application-details/${row.id}`, { id: row.id });
      }
      const editHandler = () => {
        history.push(`/create-account/${row.id}`, { id: row.id });
      }

      const handleLoadingPopupClose = () => {
        setLoadingPopup(false);
      };

      return (
        <>
          <Hidden only='xs'>
            <div>
              <List
                component="nav"
                aria-label="Device settings"
                sx={{ bgcolor: 'background.paper', padding: 0 }}
              >
                <ListItemButton
                  id="lock-button"
                  aria-haspopup="listbox"
                  aria-controls="lock-menu"
                  aria-label="when device is locked"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClickListItem}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <ActionIcon />
                </ListItemButton>
              </List>
              <Menu
                id="lock-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                MenuListProps={{
                  'aria-labelledby': 'lock-button',
                  role: 'listbox',
                  style: {
                    padding: '8px',
                    borderRadius: '16px'
                  }
                }}

              >
                {[...options?.filter((option) => option)].map((option: any, index: any) => (
                  <MenuItem
                    key={index}
                    disabled={option?.disable}
                    onClick={(event) => handleMenuItemClick(event, index, option)}
                    sx={{
                      '&:focus': {
                        backgroundColor: palette.primary[50],
                        color: palette.primary[500],
                        borderRadius: '8px'
                      },
                    }}
                  >
                    {option?.label}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </Hidden>

          <Hidden smUp>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Tooltip title="edit">
                <IconButton
                disabled={`${row?.status ?? ''}`?.toLowerCase() !== 'draft'}
                sx={{
                  width: 22,
                  height: 22,
                  p: 0.5,
                  ':hover': { bgcolor: '#F4FCFC' },
                  '&.Mui-disabled': {
                  opacity: 0.4,
                  cursor: 'not-allowed',
                  },
                }}
                onClick={editHandler}
                >
                  <CardMedia
                    component="img"
                    src="/images/edit-icon-outlined.svg"
                    alt="edit"
                    sx={{ width: '30px' }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Resend">
                <IconButton
                disabled={`${row?.status ?? ''}`?.toLowerCase() !== 'consent_sent_to_applicants'}
                  sx={{
                    width: 22,
                    height: 22,
                    p: 0.5,
                    ':hover': { bgcolor: '#F4FCFC' },
                    '&.Mui-disabled': {
                    opacity: 0.4,
                    cursor: 'not-allowed',
                  },
                  }}
                  onClick={resendHandler}
                >
                  <CardMedia
                    component="img"
                    src="/images/link-icon.svg"
                    alt="Link"
                    sx={{ width: '30px' }}
                  />
                </IconButton>
              </Tooltip>


              <Tooltip title="Delete">
                <IconButton
                  sx={{
                    width: 22,
                    height: 22,
                    p: 0.5,
                    ':hover': { bgcolor: '#F4FCFC' },
                  }}
                  // onClick={() => {
                  //   // setId(row.id);
                  //   // setDialogLoading(true);
                  //   // setCheckPoaOrNI(row.hasPOA || checkIfApplicationIsNonIndividual(row));
                  // }}
                  onClick={deleteHandler}
                >
                  <DeleteOutlineIcon color={'error'} fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Download">
                <IconButton
                disabled={[APPLICATION_LISTING_STATUS.rejected].includes(APPLICATION_LISTING_STATUS[row.status]) ? true : false}  
                  sx={{
                    width: 22,
                    height: 22,
                    p: 0.5,
                    ':hover': { bgcolor: '#F4FCFC' },
                    '&.Mui-disabled': {
                  opacity: 0.4,
                  cursor: 'not-allowed',
                  },
                  }}
                  // onClick={() => {
                  //   // setId(row.id);
                  //   // setDialogLoading(true);
                  //   // setCheckPoaOrNI(row.hasPOA || checkIfApplicationIsNonIndividual(row));
                  // }}
                  onClick={downloadHandler}
                >
                  <CardMedia
                    component="img"
                    src='/images/download-icon.png'
                    alt="Download"
                  //sx={{ width: '30px' }}
                  />
                </IconButton>
              </Tooltip>

              {/* <Tooltip title="View Info">
                <IconButton
                  sx={{
                    width: 22,
                    height: 22,
                    p: 0.5,
                    ':hover': { bgcolor: '#F4FCFC' },
                  }}
                  onClick={infoHandler}
                >
                  <Info fontSize="small" />
                </IconButton>
              </Tooltip> */}
            </Box>
          </Hidden>

          {/* <ViewInfo open={viewInfoOpen} handleClose={handleClose} /> */}
          <LoadingDialog
            loadingPopup={loadingPopup}
            onLoadingPopupClose={handleLoadingPopupClose}
            loaderText={'Downloading'}
          />
        </>

      );
    },
  };

  return (
    <CommonLayout>
      <>
        <Box>
          <Box sx={{ marginBottom: '20px' }}>
            <Typography sx={{ color: 'text.primary' }} variant='h1'>Joint Account Status</Typography>
          </Box>

          <Box
            sx={{
              borderRadius: '25px',
              overflow: 'hidden',
              backgroundColor: palette.background.paper,
              width: '100%',
            }}
          >
            <Grid
              container
              sx={{
                p: '35px 30px',
                pb: 0,
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                bgcolor: 'common.white',
              }}>
              <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
                <Grid item>
                  <TextField
                    id="outlined-multiline-flexible"
                    value={search}
                    placeholder="Search Application"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSearchText(e)}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: '5px',
                        border: `1px solid ${palette.text.secondary}B2`,
                        height: '40px',
                        width: '100%',
                        maxWidth: '255px',
                        ...theme.typography.body_400,
                        background: 'transparent'
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#B2B2B2',
                        },
                        '&:hover fieldset': {
                          borderColor: '#B2B2B2',
                        },
                      },
                      '& input': {
                        backgroundColor: 'transparent',
                      },
                      '& .MuiAutocomplete-option': {
                        backgroundColor: 'transparent',
                        '&[aria-selected]': {
                          backgroundColor: 'transparent',
                          color: '#000',
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '25px', flexDirection: 'row' }}>
                  <FilterOptions {...{ filters, open, handleFiltersAnchorEl, handleFiltersAnchorElClose, filtersAnchorEl, distributorLoading, setPage, setFilters, setFiltersAnchorEl, totalFilters, setTotalFilters }} />
                  <Button disabled={[USER_ROLES.AMC_ADMIN].includes(role)} style={{ height: '40px', background: palette.primary[500], borderRadius: '4px', width: '100%', padding: '12px', gap: '12px', opacity: [USER_ROLES.AMC_ADMIN].includes(role) ? 0.5 : 1 }}
                    onClick={() => history.push('/create-account')}>
                    <PlusIcon />
                    <Typography variant='body_400' style={{ color: palette.textDark.primary, fontWeight: 500 }}>Create Account</Typography>
                  </Button>
                </Grid>
                <Grid item>{/* <FilterMenu /> */}</Grid>
              </Grid>
            </Grid>
            <Box sx={{
              width: '100%',
              overflowX: 'auto'
            }}>
              <DataTable
                isLoading={isLoading}
                tableHeader={[...getTableHeader(), additionalCell]}
                tableData={applicationsListData}
                rowCustomStyles={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '.MuiTableCell-body ': { color: palette.text.primary, fontWeight: 500 },
                  background: 'transparent',
                }}
                boxStyles={{ minWidth: 100 }}
              />

            </Box>
            {!!applicationsList?.length && (
              <TablePagination
                style={{
                  color: palette.text.primary[500],
                  fontSize: 16,
                  fontWeight: 500,
                  padding: '20px 35px 35px 35px',
                  // paddingLeft: '50px',
                  // paddingBottom: '48px'
                }}
                rowsPerPageOptions={[]}
                labelRowsPerPage=""
                component="div"
                count={totalCount}
                rowsPerPage={limit}
                page={currentPage - 1}
                onPageChange={(event, num) => setPage(num + 1)}
                // onRowsPerPageChange={(rowsPerPage) => console.log('rowsPerPage', rowsPerPage.target.value)}
                sx={{
                  color: palette.text.primary[500]
                }} />
              // <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
              //   <Pagination
              //     count={noOfPages}
              //     page={currentPage}
              //     color="primary"
              //     onChange={handlePageChange}
              //   />
              // </Stack>
            )}
          </Box>
          {/* {!!applicationsList.length && (
            <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
              <Pagination
                count={noOfPages}
                page={currentPage}
                color="primary"
                onChange={handlePageChange}
              />
            </Stack>
          )} */}
        </Box>
        <ConfirmationDialog
          message={'Are you sure you want to delete Application ?'}
          open={deletePopUp !== null}
          setOpen={() => setDeletePopUp(null)}
          onSave={async () => {
            try {
              setDeletePopUp(null);
              const _application = (await dispatch(
                getApplicationDetails(deletePopUp?.id || '', 'delete')
              )) as unknown as { code: string; message: string };
              if (_application.code === 'SUCCESS') {
                getApplication()
              } else {
                enqueueSnackbar('Something wrong', {
                  variant: 'error',
                  autoHideDuration: 3000,
                });
              }
              enqueueSnackbar('Application Deleted Successfully', {
                variant: 'success',
                autoHideDuration: 3000,
              });
            } catch (e) {
              console.error((e as Error).message);
            }
          }}
          onCancel={() => setDeletePopUp(null)}
        />
        <Dialog
          onClose={handleClose}
          open={open}
          sx={{
            '.MuiPaper-root ': {
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <Grid
            item
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            p={4}
            pb={2}>
            <Typography sx={{ color: 'primary.main', fontSize: '20px', fontWeight: 500 }}>
              Get Link
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Grid>
          {applicationRefsList &&
            applicationRefsList.map((ref) => {
              return (
                <React.Fragment key={ref.id}>
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    px={4}
                    py={1}
                    sx={{
                      ':hover': {
                        bgcolor: '#F4FCFC',
                      },
                      ':last-of-type': {
                        mb: 5,
                      },
                    }}>
                    <Typography
                      sx={{
                        color: 'rgba(41, 49, 57, 0.7)',
                        fontSize: '18px',
                        fontWeight: 500,
                      }}>
                      Copy Link For {ref.name}
                    </Typography>
                    <Tooltip title={tooltip}>
                      <IconButton
                        onMouseOver={() => {
                          setTooltip('Copy Link');
                        }}
                        onClick={() => {
                          setTooltip('Copied'),
                            navigator.clipboard.writeText(
                              checkPoaOrNI
                                ? ref.invitationUrl
                                : `${window.location.origin}/investment-details/${ref.referenceId}/investor-login`
                            );
                        }}>
                        <CardMedia
                          component="img"
                          src="/images/link-icon.svg"
                          alt="Link"
                          sx={{ width: '35px' }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </React.Fragment>
              );
            })}
        </Dialog>
        <Dialog
          onClose={handleDialogClose}
          open={isDialogLoading}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 20,
                fontWeight: 500,
              },
            }}>
            <Typography sx={{ color: 'primary.main', lineHeight: '35px', textAlign: 'center' }}>
              Loading...
            </Typography>
          </Box>
        </Dialog>
        <ResendOtpDialog isResendOtpDialogOpen={isResendOtpDialogOpen} handleResendOtpDialogClose={handleResendOtpDialogClose} resendOTPDialogId={resendOTPDialogId} application={resendOTPApplicants} />
        {/* <Dialog
          onClose={handleResendOtpDialogClose}
          open={isResendOtpDialogOpen}
          fullWidth
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "15px",
              backgroundColor: "background.default",
              maxWidth: "600px",
              padding: "25px",
              m: 0
            }
          }}
        >
          <DialogContent sx={{ p: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h2" sx={{ fontWeight: 600 }}>
                Resend Consent OTP
              </Typography>
              <IconButton onClick={handleResendOtpDialogClose}>
                <DialogCloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ mt: 4 }}>
              <Grid container spacing={2}>
                {["PRIMARY", "JOINT_1", "JOINT_2"].map((type) => {
                  // const name = getApplicantName(type as Applicant["type"]);
                  // if (!name) return null;
                  return (
                    <Grid item xs={12} key={type} sx={{ mb: 2, display: "flex", flexDirection: "row" }}>

                      <Typography variant="body_500" sx={{ fontWeight: 600, mb: 2, width: "50%" }}>
                        {type === "PRIMARY" ? "Applicant" : "Joint Holder"} ({type === "PRIMARY" ? "Primary" : type === "JOINT_1" ? "Joint Holder 1" : "Joint Holder 2"})
                      </Typography>

                      <Button
                        variant="outlined"
                        // disabled={resending[type as Applicant["type"]]}
                        onClick={() => console.log("resending otp to")}
                        sx={(theme: Theme) => ({
                          width: "50%",
                          padding: "10px",
                          borderColor: "primary.500",
                          color: "primary.500",
                          borderWidth: "1px",
                          "&:hover": {
                            backgroundColor: "background.paper",
                            borderColor: "primary.600"
                          },
                          ...theme.typography.body_600
                        })}
                      >
                        Send OTP
                      </Button>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>

            <DialogActions sx={{ pt: 4 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleResendOtpDialogClose}
                    sx={(theme: Theme) => ({
                      padding: "10px",
                      ...theme.typography.body_600
                    })}
                  >
                    Close
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </DialogContent>
        </Dialog> */}
      </>
    </CommonLayout>
  );
}

const FilterOptions = (props: FilterProps): JSX.Element => {
  const { filters, open, handleFiltersAnchorEl, filtersAnchorEl, setPage, setFilters, handleFiltersAnchorElClose, distributorLoading, totalFilters, setTotalFilters } = props;
  const { palette } = useTheme()
  const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId', 'diy', 'accountType', 'bseClientActivationStatus', 'onboardingType'].filter(
    (filterKey) => (filters[filterKey] as string[])?.length
  )?.length;
  // console.log('filtersAnchorEl', filtersAnchorEl)
  return (
    <>
      <Box
        // aria-controls="filter-menu"
        // aria-haspopup="true"
        // aria-expanded={open ? 'true' : undefined}
        component={'button'}
        sx={{ display: 'flex', alignItems: 'center', gap: '10px', border: 'none', background: 'transparent', cursor: 'pointer' }} onClick={handleFiltersAnchorEl}>

        <Badge
          showZero
          badgeContent={totalFilters}
          sx={(theme: Theme) => ({
            '& .MuiBadge-badge': {
              right: 0,
              top: -3,
              backgroundColor: theme.palette.primary[500],
              color: theme.palette.common.white,
              ...theme.typography.subtitle_600
            },
          })}
        >
          <FilterIcon />
        </Badge>
        <Typography variant='body_400' sx={{ fontWeight: 500, color: palette.text.primary }}>Filters</Typography>
      </Box>
      {filtersAnchorEl && (
        <FilterDropdown
          filters={filters}
          onFiltersChange={(value) => {
            setPage(1);
            setFilters(value);
          }}
          anchorEl={filtersAnchorEl}
          handleClose={handleFiltersAnchorElClose}
          // distributors={distributors}
          loader={distributorLoading}
          setTotalFilters={setTotalFilters}
        />

      )}
    </>
  );
};